import { render } from "./SkeletonProduct.vue?vue&type=template&id=1a0b7ca8"
const script = {}

import "./SkeletonProduct.vue?vue&type=style&index=0&id=1a0b7ca8&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__